import { makeAutoObservable } from 'mobx';

import { LoadWithOffer, getLoadIdsWithOffer } from 'api/offers';
import { getLoadsByIds } from 'api/search';
import { RootStore } from 'store/RootStore';
import { SelectedLoads } from 'store/UIStore/SelectedLoads';
import { LoadType } from 'types/cargosApp/Load';

export class LoadsWithOffers {
  readonly #root: RootStore;
  loadsIdsWithOffers: LoadWithOffer[];
  loadsWithOffers: LoadType[];
  count: number = 0;
  selectedLoads: SelectedLoads;

  constructor(root: RootStore) {
    this.#root = root;
    this.loadsIdsWithOffers = [];
    this.loadsWithOffers = [];
    this.selectedLoads = new SelectedLoads();

    makeAutoObservable(this);
  }

  get loads() {
    if (this.loadsWithOffers.length) {
      return this.loadsWithOffers.map(load => ({
        ...load,
        checked: this.selectedLoads.ids.includes(load.id),
      }));
    }

    return [];
  }

  updateLoad = (updatedLoad: LoadType) => {
    const indexToUpdate = this.loadsWithOffers.findIndex(load => load.id == updatedLoad.id);
    if (indexToUpdate === -1) return;

    const prevLoad = this.loadsWithOffers[indexToUpdate];
    this.loadsWithOffers[indexToUpdate] = updatedLoad;
    this.#root.loadsSync.syncLoadState(this.loadsWithOffers, prevLoad, updatedLoad);
  };

  setCount = (count: number) => {
    this.count = count;
  };

  setLoads = (loads: LoadType[]) => {
    this.loadsWithOffers = loads;
  };

  setLoadsIdsWithOffers = (loads: LoadWithOffer[]) => {
    this.loadsIdsWithOffers = loads;
  };

  updateLoads = async (isForceUpdate: boolean = false) => {
    await this.fetchLoadsWithOffers(isForceUpdate);
  };

  fetchLoadsWithOffers = async (isForceUpdate: boolean = false) => {
    try {
      if (isForceUpdate || this.loadsIdsWithOffers.length === 0) {
        const { data: loadsIdsWithOffers } = await getLoadIdsWithOffer();
        const onlyActiveLoadsIdsWithOffers = loadsIdsWithOffers.filter(load => load.HasActive);

        this.setLoadsIdsWithOffers(onlyActiveLoadsIdsWithOffers);
      }

      if (this.loadsIdsWithOffers.length > 0) {
        const perPage = this.#root.ui.pagination.followedLoadsPerPage.onlyWithOffers.data;
        const startIndex = (this.#root.ui.pagination.pages.onlyWithOffers - 1) * perPage;
        const endIndex = startIndex + perPage;

        const paginatedLoadsIdsWithOffers = this.loadsIdsWithOffers.slice(
          startIndex,
          Math.min(endIndex, this.loadsIdsWithOffers.length),
        );

        const loadsIds = paginatedLoadsIdsWithOffers.map(load => load.LoadId);
        const { data } = await getLoadsByIds(loadsIds);

        this.setCount(this.loadsIdsWithOffers.length);
        this.setLoads(data.loads);
      } else {
        this.setCount(this.loadsIdsWithOffers.length);
        this.setLoads([]);
      }
    } catch (error) {
      this.#root.errors.setRetrievable({
        name: 'fetchLoadsWithOffers',
        message: this.#root.app.i18n.errors.getLoadsWithOffers,
      });
    }
  };
}
